
(function (window, document, Math) {
  var mobileModal = {
      /**********************頁面loading***************************/
      showPageLoader: function(content) {
          var self = this;
          self.stopTouchEvent();

          var modalBox = document.querySelector(".page-loader");
          if( modalBox ) {
              document.body.removeChild(modalBox);
          }

          var modalParent = document.createElement("div");
          var modalChild = document.createElement("div");
          modalChild.innerHTML = "<div><span></span><span></span></div>";

          //有提示文字
          if(content) {
              var contentEl = document.createElement("p");
              var contentNode = document.createTextNode(content);
              contentEl.appendChild( contentNode );
              modalChild.appendChild( contentEl );
          }

          modalParent.appendChild( modalChild );
          modalParent.className = "zx-mask page-loader";
          document.body.appendChild( modalParent );
      },
      //關閉page-loader動畫
      hidePageLoader: function() {
          var self = this;
          var modalBox = document.querySelector(".page-loader");
          modalBox.className = "zx-mask page-loader clear-page-loader";
          if( modalBox ) {
              setTimeout(function () {
                  self.startTouchEvent();
                  document.body.removeChild( modalBox );
              }, 500);
          }
      },

      //禁止默認事件
      touchDefault: function (e) {
          e.stopPropagation();
          e.preventDefault();
      },
      //禁止touch事件
      stopTouchEvent: function () {
          var self = this;
          document.addEventListener('touchstart', self.touchDefault, false);
          document.addEventListener('touchmove', self.touchDefault, false);
          document.addEventListener('touchend', self.touchDefault, false);
      },
      //啟動touch事件
      startTouchEvent: function () {
          var self = this;
          document.removeEventListener('touchstart', self.touchDefault, false);
          document.removeEventListener('touchmove', self.touchDefault, false);
          document.removeEventListener('touchend', self.touchDefault, false);
      }
  };

  if ( typeof module != 'undefined' && module.exports ) {
      module.exports = mobileModal;
  } else {
      window.mobileModal = mobileModal;
  }
})(window, document, Math);



